// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skitterbook-live-print-side-margin-container {
    display: flex;
    justify-content: center;
}

.lpmi-page {
    width: fit-content;
    align-self: center;
    background-color: gray;
}

.lpmi-row {
    display: flex;
}

.lpmi-col {
    width: 33.33%;
}

.lpmi-row.r1 > .lpmi-col.c2, .lpmi-row.r3 > .lpmi-col.c2 {
    display: flex;
    justify-content: center;
}

.lpmi-row.r2 > .lpmi-col.c1 {
    display: flex;
    justify-content: end;
}

.lpmi-row.r2 > .lpmi-col.c3 {
    display: flex;
    justify-content: start;
}

.lpmi-row.r2 > .lpmi-col.c2 {
    width: 8rem;
    aspect-ratio: 210 / 297;
    background-color: white;
    margin: 1rem;
    padding: 0.85rem 0.5rem;
    border: solid 0.5rem lightgray;
}

    .lpmi-row.r2 > .lpmi-col.c2 > span {
        border-top: solid 1px var(--color-component-foreground);
        border-left: solid 1px var(--color-component-foreground);
        color: var(--color-component-foreground);
        padding: 0.5rem;
    }
`, "",{"version":3,"sources":["webpack://./src/Skitterbook/css/SkitterBookLivePrintSideMargin.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,uBAAuB;IACvB,8BAA8B;AAClC;;IAEI;QACI,uDAAuD;QACvD,wDAAwD;QACxD,wCAAwC;QACxC,eAAe;IACnB","sourcesContent":["@import '../../css/App.css';\r\n\r\n.skitterbook-live-print-side-margin-container {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.lpmi-page {\r\n    width: fit-content;\r\n    align-self: center;\r\n    background-color: gray;\r\n}\r\n\r\n.lpmi-row {\r\n    display: flex;\r\n}\r\n\r\n.lpmi-col {\r\n    width: 33.33%;\r\n}\r\n\r\n.lpmi-row.r1 > .lpmi-col.c2, .lpmi-row.r3 > .lpmi-col.c2 {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.lpmi-row.r2 > .lpmi-col.c1 {\r\n    display: flex;\r\n    justify-content: end;\r\n}\r\n\r\n.lpmi-row.r2 > .lpmi-col.c3 {\r\n    display: flex;\r\n    justify-content: start;\r\n}\r\n\r\n.lpmi-row.r2 > .lpmi-col.c2 {\r\n    width: 8rem;\r\n    aspect-ratio: 210 / 297;\r\n    background-color: white;\r\n    margin: 1rem;\r\n    padding: 0.85rem 0.5rem;\r\n    border: solid 0.5rem lightgray;\r\n}\r\n\r\n    .lpmi-row.r2 > .lpmi-col.c2 > span {\r\n        border-top: solid 1px var(--color-component-foreground);\r\n        border-left: solid 1px var(--color-component-foreground);\r\n        color: var(--color-component-foreground);\r\n        padding: 0.5rem;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
